import { apiRequest } from "util/services";

export const NOTICE_ALERTS_PATH = "notice/alerts";

/**
 * Hierarchical query keys; list() includes all server-side list parameters so each
 * page / sort / search combination is cached separately.
 */
export const noticeAlertsQueryKeys = {
  all: (uid) => ["notice", "alerts", uid ?? "anonymous"],
  lists: (uid) => [...noticeAlertsQueryKeys.all(uid), "list"],
  list: (uid, params) => [
    ...noticeAlertsQueryKeys.lists(uid),
    params.startIndex,
    params.numPerPage,
    params.sort,
    params.condition ?? "all",
    params.keyword ?? "",
  ],
};

/** Notification drawer (`AlertsPanel`) — first page, 5 rows. */
export const NOTICE_ALERTS_PANEL_LIST_PARAMS = {
  startIndex: 0,
  numPerPage: 5,
  sort: "newest",
  condition: "all",
  keyword: "",
};

/**
 * @param {object} params
 * @param {number} params.startIndex
 * @param {number} params.numPerPage
 * @param {string} params.sort
 * @param {string} [params.condition]
 * @param {string} [params.keyword]
 * @returns {Promise<{ alerts: any[], totalCount: number }>}
 */
export async function fetchNoticeAlerts(params) {
  const res = await apiRequest(
    NOTICE_ALERTS_PATH,
    "POST",
    {
      start_index: params.startIndex,
      num_per_page: params.numPerPage,
      condition: params.condition ?? "all",
      sort: params.sort,
      keyword: params.keyword ?? "",
    },
    true,
  );
  if (res === false || res?.cancel) {
    throw new Error("ALERTS_REQUEST_FAILED");
  }
  if (!res?.success) {
    throw new Error(
      typeof res?.error === "string" ? res.error : "ALERTS_REQUEST_FAILED",
    );
  }
  return {
    alerts: res.success?.alerts ?? [],
    totalCount: res.success?.number_alerts ?? 0,
    limits: res.success?.limits ?? null,
  };
}
